import React from "react";

export default function CheckList({ items }) {
  return (
    <ul className="check-list">
      {items.map((item) => <li key={item}>{item}</li>)}
    </ul>
  );
}
